import Axios from '@/common/require'
export default{
  // 管理员列表
  GET_MANAGER_LIST (store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/manager/index',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 管理员详情
  GET_MANAGER_INFO (store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/manager/info',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 修改管理员详情
  UPDATA_MANAGER_INFO (store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/manager/update',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 删除管理员
  DEL_MANAGER (store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/console/manager/delete',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 新增管理员
  CREATE_MANAGER_INFO(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/console/manager/create',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
// 设置/批量 设置为顾问
  SET_MANAGER_GROUP_INFO(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/manager/group_update',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
// 管理组列表
  GET_GROUP_LIST (store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/group/index',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 管理组权限详情
  GET_GROUP_INFO (store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/group/info',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },

  // 管理组信息详情
  GET_GROUP_INFO_DETAIL(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/group/group_info',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 管理组信息修改
  UPDATA_GROUP_INFO_DETAIL(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/group/update',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 管理组删除
  DEL_GROUP(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/group/delete',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 新建管理组
  CREATE_GROUP(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/group/create',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 管理组权限更新
  UPDATA_GROUP(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/group/setup',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 角色列表
  GET_ROLE_LIST (store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/role/index',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 角色详情
  GET_ROLE_INFO (store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/role/info',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 管理组下拉列表（用于角色详情）
  GET_GROUPLIST (store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/api/index/group',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 更新角色详情
  UPDATA_ROLE_INFO (store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/role/update',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 新建角色
  CREATEE_ROLE (store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/role/create',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 删除角色
  DEL_ROLE (store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/role/delete',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 角色下拉列表（用于用户详情）
  GET_ROLELIST (store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/api/index/role',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 批量设置角色
  UPDATA_ROLA (store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/manager/group_update',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/management/actions.js